import { Component, OnInit } from "@angular/core";
import { ImageCarouselItem } from "../base/image-carousel/model/image-carousel-item.model";
import { mainSlideInAnimation } from "./main-route-animation";

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.scss"],
  animations: [mainSlideInAnimation]
})
export class MainComponent implements OnInit {
  public carouselItems: Array<ImageCarouselItem> = [
    new ImageCarouselItem(
      "/main-carousel/img (1).jpg",
      "Dunaszentmiklós község honlapja",
      "right"
    ),
    new ImageCarouselItem(
      "/main-carousel/img (2).jpg",
      "Nemzetiségi önkormányzat",
      "center"
    ),
    new ImageCarouselItem(
      "/main-carousel/img (3).jpg",
      "Magyar vagyok, svábnak születtem",
      "left"
    )
  ];

  constructor() {}

  ngOnInit(): void {}
}
